<section class="row text-wide-content-block">
  <div class="offset-sm-2 col-sm-20 col-md-16 mx-md-auto text-wide-content-block__inner">
    <h1 class="h3" *ngIf="block.title">{{ block.title }}</h1>
    <div class="text-wide-content-block__text" *ngIf="block.text" [innerHTML]="block.text"></div>
  </div>
</section>
